module.exports = __webpack_public_path__ + "media/partners/starbucks-5cdbdb64.svg";